import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { segmentacionesService } from "src/services/unoauno/apiSegmentaciones";
import { GlobalConstants } from "src/data/GlobalConstants";
import { modalCRUDService } from "src/services/modalCRUDService";
import FilterTable from "src/components/FilterTable";
import ExternalActionsTable from "src/components/ExternalActionsTable";
import AgGridTable from "src/components/AgGridTable";
import ExcelToJSON from "src/components/ExcelToJSON";
import { alertQuestionService } from "src/services/alertQuestionService";
import { generalService } from "src/services/unoauno/apiGeneral";

const COLUMN_DEF = [
    {headerName: '', field: "select", resizable: true, sortable: true, filter: true, minWidth: 70, headerCheckboxSelection: true, checkboxSelection: true},
    {headerName: "ID de cliente", field: "idCliente", minWidth: 100, resizable: true, sortable: false, filter: false},
    {headerName: "ID de negocio", field: "idNegocio", minWidth: 110, resizable: true, sortable: false, filter: false},
    {headerName: "Nombre de cliente", field: "nombreCliente", minWidth: 232, resizable: true, sortable: false, filter: false}
];

const CustomExternalActions = ({dispatch, reload, idSegmentacion, setClientesDisponibles, setClientesSegmentacion, clientesSegmentacion}) => {
    const [file, setFile] = useState(null)

    const onUploadExcelClients = async (datos, file) => {
        try {
            const xlsxDescripcion = new File ([file], "Segmentaciones Asginar-Clientes")
            setFile(xlsxDescripcion)

            const res = await segmentacionesService.validarExcelClientes(datos[0].data)

            if(res.data.error.length > 0){
                alertQuestionService.showAlert({
                    title: `Ha ocurrido un error al realizar el cargue`, question: ``,
                    message: `No se encontraron los siguientes clientes: `,
                    html: 
                    <div className="customScroll" style={{width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", fontSize: "11pt", maxHeight: "48vh", overflow: "auto"}}>
                        <table className="tableError">
                            <thead>
                                <tr>
                                    <th>Fila</th>
                                    <th>Codigo de cliente</th>
                                    <th>Codigo de negocio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {res.data.error.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.row}</td>
                                            <td>{item.idCliente}</td>
                                            <td>{item.idNegocio}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>,
            
                    actionBtnAceptar: () => alertQuestionService.clear(),
                    type: GlobalConstants.alertInfo,
                    size: 'sm'
                })

            }else {
                setClientesDisponibles(prev => prev.filter(el => !res.data.dataValidate.some(el2 => el2.idCliente == el.idCliente && el2.idNegocio == el.idNegocio)))
                setClientesSegmentacion(prev => [...prev, ...res.data.dataValidate])
                setClientesSegmentacion(prev => prev.filter((el, index, self) => index == self.findIndex((t) => (t.idCliente == el.idCliente && t.idNegocio == el.idNegocio))))
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Excel inválido' } });
        }
    }

    const onSaveClients = async () => {
        alertQuestionService.showAlert({
            title: `Asignar Clientes`, question: ``,
            message: `¿Estás seguro de asignar estos clientes a la segmentación?`,
    
            actionBtnAceptar: async () => {
                alertQuestionService.clear();
                try {
                    await segmentacionesService.saveClientsSegmentacion({ idSegmentacion, clientes: clientesSegmentacion })

                    if(file && clientesSegmentacion.length > 0) await generalService.saveExcel({ file })

                    reload()
                    modalCRUDService.clear();
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
                } catch (error) {
                    console.log(error);
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } })
                }
            },
            actionBtnCancelar: () => alertQuestionService.clear(),
            type: GlobalConstants.alertInfo,
            size: 'sm'
        })
    }

    return (
        <div className="d-flex align-items-center">
            <ExcelToJSON
                identificador="cargueClientes" 
                handleChange={(datos, file) => onUploadExcelClients(datos, file)}
                titleTooltip="Cargue masivo"
                color={Colors.COLOR_GREEN_DARK}
            />
            <Tooltip className="m-0 ml-3 mr-1" title="Guardar Cambios" aria-label="saveChanges">
                <a onClick={() => onSaveClients()} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.GREEN_SWITCH_ACTIVE}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save"/>
                </a>
            </Tooltip>
        </div>
    )
}

const FormCRUDSegmentacionesClientes = ({ properties }) => {
    const { data: { idProveedor, idSegmentacion, nombreSegmentacion, clientes, clientesD, reload } } = properties;
    const dispatch = useDispatch();

    const [clientesSegmentacion, setClientesSegmentacion] = useState(clientes);
    const [clientesDisponibles, setClientesDisponibles] = useState(clientesD);
    const [valueSearch, setValueSearch] = useState("");

    const tableRefDisponibles = useRef(null);
    const tableRefActuales = useRef(null);

    const searchClientes = async (value) => {
        setValueSearch(value);

        try {
            const res = await segmentacionesService.getClientesDisponibles({ search: value, idProveedor });
            const clientesFiltrados = res.data.filter(cli => !clientesSegmentacion.some(cliS => (cliS.idCliente == cli.idCliente && cliS.idNegocio == cli.idNegocio))) ?? [];
            setClientesDisponibles(clientesFiltrados);
        } catch (error) {
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } })
        }
    }

    const addClients = () => {
        const selectedRows = tableRefDisponibles.current.api.getSelectedRows();
        const clientesActuales = [...clientesSegmentacion, ...selectedRows.filter(cli => !clientesSegmentacion.some(cliS => (cliS.idCliente == cli.idCliente && cliS.idNegocio == cli.idNegocio)))];
        const clientesDisponiblesFiltrados = clientesDisponibles.filter(cli => !selectedRows.some(cliS => (cliS.idCliente == cli.idCliente && cliS.idNegocio == cli.idNegocio)));

        setClientesSegmentacion(clientesActuales);
        setClientesDisponibles(clientesDisponiblesFiltrados);
    }

    const removeClients = () => {
        const selectedRows = tableRefActuales.current.api.getSelectedRows();
        const clientesDisponiblesFiltrados = [...clientesDisponibles, ...selectedRows];
        const clientesActuales = clientesSegmentacion.filter(cli => !selectedRows.some(cliS => (cliS.idCliente == cli.idCliente && cliS.idNegocio == cli.idNegocio)));

        setClientesSegmentacion(clientesActuales);
        setClientesDisponibles(clientesDisponiblesFiltrados);
    }

    return (
        <div className="w-100 row m-0 p-0" style={{height: "75vh"}}>
            <div className="col px-2">
                <span className="ml-2" style={{fontSize: "12pt", fontWeight: "bold"}}>Clientes disponibles:</span>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center w-50" style={{marginTop: "-10px"}}>
                        <InputForm
                            identificador="searchFilterClientesDisponibles"
                            value={valueSearch}
                            label=""
                            placeholder="Buscar..."
                            className="w-100 mx-2"
                            handleChange={({name, value}) => searchClientes(value)}
                        />
                    </div>
                </div>
                <div className="mx-2">
                    <AgGridTable
                        referencia={tableRefDisponibles}
                        columnDef={COLUMN_DEF}
                        height="64vh"
                        defaultColDef={{wrapHeaderText: true, autoHeaderHeight: true}}
                        dataList={clientesDisponibles}
                        rowSelection={'multiple'}
                        onGridReady={params => params.api.sizeColumnsToFit()}
                    />
                </div>
            </div>
            
            <div className="h-100 d-flex align-items-center justify-content-center" style={{width: "5vw"}}>
                <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{gap: "15px"}}>
                    <Tooltip className="m-0" title="Agregar clientes" aria-label="agregarClientes">
                        <a onClick={() => addClients()} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.GREEN_SWITCH_ACTIVE}}/>
                            <i style={{color: Colors.GREEN_SWITCH_ACTIVE}} className="fas fa-arrow-right"/>
                        </a>
                    </Tooltip>

                    <Tooltip className="m-0" title="Remover clientes" aria-label="removerClientes">
                        <a onClick={() => removeClients()} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-arrow-left"/>
                        </a>
                    </Tooltip>
                </div>
            </div>

            <div className="col px-2">
                <span className="ml-2" style={{fontSize: "12pt", fontWeight: "bold"}}>Clientes en la segmentación:</span>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center w-50" style={{marginTop: "-10px"}}>
                        <FilterTable tableRef={tableRefActuales} identificador="searchFilterClientes" className="w-100 mx-2" />
                    </div>

                    <ExternalActionsTable
                        customActions={ <CustomExternalActions 
                            dispatch={dispatch}
                            reload={reload}
                            idSegmentacion={idSegmentacion}
                            setClientesDisponibles={setClientesDisponibles}
                            setClientesSegmentacion={setClientesSegmentacion}
                            clientesSegmentacion={clientesSegmentacion}
                        />}
                        accionExcel={{
                            tableRef: tableRefActuales,
                            fileName: `Clientes Segmentación - ${nombreSegmentacion}`,
                            sheetName: "Clientes en la segmentación",
                            structure: [
                                { fieldOld: "idCliente", fieldNew: "Codigo de cliente" },
                                { fieldOld: "idNegocio", fieldNew: "Codigo de negocio" },
                                { fieldOld: "nombreCliente", fieldNew: "Nombre de cliente" },
                            ]
                        }}
                    />
                </div>
                <div className="mx-2">
                    <AgGridTable
                        referencia={tableRefActuales}
                        columnDef={COLUMN_DEF}
                        height="64vh"
                        defaultColDef={{wrapHeaderText: true, autoHeaderHeight: true}}
                        dataList={clientesSegmentacion}
                        rowSelection={'multiple'}
                        onGridReady={params => params.api.sizeColumnsToFit()}
                    />
                </div>
            </div>
        </div>
    )
}

export default FormCRUDSegmentacionesClientes;